// Convert severity to CSS class name (handles both "Best Practice" and "bestPractice" formats)
export const getSeverityClass = (severity: string): string => {
	return (
		severity
			// Handle spaces
			.replace(/\s+/g, '-')
			// Handle camelCase (insert dash before uppercase letters)
			.replace(/([a-z])([A-Z])/g, '$1-$2')
			.toLowerCase()
	);
};

// Convert camelCase to proper display format (bestPractice => Best Practice)
export const formatSeverityText = (severity: string): string => {
	return (
		severity
			// Insert space before uppercase letters
			.replace(/([a-z])([A-Z])/g, '$1 $2')
			// Capitalize first letter of each word
			.replace(/\b\w/g, (letter) => letter.toUpperCase())
	);
};
